<template>
  <div>
    <div class="form-wrap">
      <div class="tab-wrap">
        <div v-for="item in tabs" :key="item.title" :class="{ active: item.path === currentTab }" class="tab-item pointer" @click="hanleTabClick(item)">
          <i :class="item.icon" />
          {{ item.title }}
        </div>
      </div>
      <el-form :model="dataForm" class="search-form">
        <div class="search-wrap">
          <el-form-item style="flex: 1">
            <el-input v-model="dataForm.str" placeholder="请输入" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" style="background-image: linear-gradient(110deg, #5787ff 0%, #1b5bfa 100%)" @click="onsearch"
              >搜索</el-button
            >
          </el-form-item>
        </div>
        <el-form-item>
          <!-- <div class="hot-search">
            <span> 热门搜索： </span>
            <div class="hot-wrap">
              <a v-for="item in hotSearchList" :key="item.text" :href="item.link">{{ item.text }}</a>
            </div>
          </div> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="max-width">
      <Person v-if="currentTab == 'person'" />
      <Unit v-if="currentTab == 'unit'" />
    </div>
  </div>
</template>

<script>
import Person from './components/Person'
import Unit from './components/Unit'
export default {
  name: 'PolicyInquiriesRole',
  components: { Person, Unit },
  provide() {
    return {
      searchParmas: this.searchParmas,
    }
  },
  data() {
    return {
      searchParmas: { value: '' },
      tabs: [
        {
          icon: 'el-icon-user',
          title: '个人政策',
          path: 'person',
        },
        {
          icon: 'el-icon-office-building',
          title: '单位政策',
          path: 'unit',
        },
      ],
      currentTab: 'person',
      dataForm: {},
      hotSearchList: [
        { link: 'javascript:;', text: '生活安居类' },
        { link: 'javascript:;', text: '培养升级类' },
        { link: 'javascript:;', text: '引才支持类' },
      ],
    }
  },
  computed: {
    policy() {
      return this.$route.params.role
    },
  },
  mounted() {
    this.currentTab = this.policy || this.currentTab
    document.documentElement.scrollTop = 0
  },
  methods: {
    hanleTabClick(item) {
      this.$router.push({
        path: `/policy-inquiries/${item.path}`,
      })
      this.currentTab = item.path
    },
    onsearch() {
      this.searchParmas.value = this.dataForm.str
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
